<template>
    <div class="c-app">
        <CWrapper v-if="this.store.myUser.onlineTrainingDoScreenPhotosExhibitionMode">
            <CCard class="profile" style="min-height: 100%">
                <!--suppress CssReplaceWithShorthandSafely -->
                <CImg draggable="false" :src="fileUrl($route.params.thumbnailId)"
                      style="user-select: none; display: block; margin-left: auto; margin-right: auto; width: 700px; margin-bottom: 20px; margin-top: 20px;
                       border-radius: 10px;"/>
                <CCardBody v-if="!success">
                    <CForm @submit.prevent="onSubmit">
                        <CRow style="justify-content: center">
                            <CCol lg="5">
                                <CCard>
                                    <CCardHeader>
                                        <strong>Roweron training photo request</strong>
                                    </CCardHeader>
                                    <CCardBody>
                                        <CRow>
                                            <CCol sm="6">
                                                <CInput
                                                    required
                                                    label="Email"
                                                    type="email"
                                                    :is-valid="errors.emailIsValid"
                                                    :invalid-feedback="errors.emailInvalidFeedback"
                                                    v-model="email"
                                                />
                                            </CCol>
                                            <CCol sm="6">
                                                <CInput
                                                    required
                                                    label="Full name"
                                                    :is-valid="errors.nameIsValid"
                                                    :invalid-feedback="errors.nameInvalidFeedback"
                                                    v-model="name"
                                                />
                                            </CCol>
                                        </CRow>

                                        <CRow class="form-group mt-2">
                                            <CCol tag="label" class="col-form-label">
                                                Would you buy Roweron Smart Screen and its subscription? If yes, for what price?
                                            </CCol>
                                        </CRow>
                                        <CRow>
                                            <CCol style="margin-top: -10px;" >
                                                <CInputRadioGroup
                                                    class="home-form__radio"
                                                    custom
                                                    :options="[
                                                            {value: '300_and_39_mo', label: '300$ and 39$/mo'},
                                                            {value: '400_and_29_mo', label: '400$ and 29$/mo'} ,
                                                            {value: '500_and_19_mo', label: '500$ and 19$/mo'},
                                                            {value: 'no', label: 'I wouldn\'t buy'}
                                                            ]"
                                                    :is-valid="errors.whouldYouBuyAnswerIsValid"
                                                    :invalid-feedback="errors.whouldYouBuyAnswerInvalidFeedback"
                                                    :checked.sync="whouldYouBuyAnswer"
                                                />
                                            </CCol>
                                        </CRow>

                                        <template v-if="whouldYouBuyAnswer === 'no'">
                                            <CRow class="form-group mt-2">
                                                <CCol tag="label" class="col-form-label">
                                                    Why you are not going to buy the Roweron screen?
                                                </CCol>
                                            </CRow>
                                            <CRow>
                                                <CCol style="margin-top: -10px;" >
                                                    <CInputRadioGroup
                                                        class="home-form__radio"
                                                        custom
                                                        :options="[
                                                            {value: 'another_smart_rower', label: 'I already have another Smart Rower at home'},
                                                            {value: 'no_rower', label: 'I don\'t have a rower at home'} ,
                                                            // {value: 'high_price', label: 'The suggested price options are too high.'} ,
                                                            {value: 'not_interested', label: 'I have a rower. I\'m not intersted'}
                                                            ]"
                                                        :is-valid="errors.whyWouldntBuyAnswerIsValid"
                                                        :invalid-feedback="errors.whyWouldntBuyAnswerInvalidFeedback"
                                                        :checked.sync="whyWouldntBuyAnswer"
                                                    />
                                                </CCol>
                                            </CRow>
                                        </template>
                                        <template v-else-if="whouldYouBuyAnswer">
                                            <CRow class="form-group mt-2">
                                                <CCol tag="label" class="col-form-label">
                                                    Usage
                                                </CCol>
                                            </CRow>
                                            <CRow>
                                                <CCol style="margin-top: -10px;" >
                                                    <CInputRadioGroup
                                                        class="home-form__radio"
                                                        custom
                                                        :options="[
                                                            {value: 'personal', label: 'Personal'},
                                                            {value: 'commercial', label: 'Commercial'}
                                                            ]"
                                                        :is-valid="errors.usageTypeAnswerIsValid"
                                                        :invalid-feedback="errors.usageTypeAnswerInvalidFeedback"
                                                        :checked.sync="usageTypeAnswer"
                                                    />
                                                </CCol>
                                            </CRow>
                                        </template>
                                        <template  v-if="whyWouldntBuyAnswer === 'not_interested' && whouldYouBuyAnswer && whouldYouBuyAnswer === 'no'">
                                            <CRow class="mt-3">
                                                <CCol sm="12">
                                                    <CInput
                                                        required
                                                        label="We are curious: why are you not interested? (last question)"
                                                        :is-valid="errors.customReasonNotToBuyAnswerIsValid"
                                                        :invalid-feedback="errors.customReasonNotToBuyAnswerInvalidFeedback"
                                                        v-model="customReasonNotToBuyAnswer"
                                                    />
                                                </CCol>
                                            </CRow>
                                        </template>
                                        <template  v-if="whyWouldntBuyAnswer === 'another_smart_rower' && whouldYouBuyAnswer && whouldYouBuyAnswer === 'no'">
                                            <CRow class="mt-3">
                                                <CCol  sm="6">
                                                    <CInput
                                                        required
                                                        label="Your rower brand (last question)"
                                                        :is-valid="errors.alreadyOwnedRowerBrandAnswerIsValid"
                                                        :invalid-feedback="errors.alreadyOwnedRowerBrandAnswerInvalidFeedback"
                                                        v-model="alreadyOwnedRowerBrandAnswer"
                                                    />
                                                </CCol>
                                            </CRow>
                                        </template>
                                        <template  v-if="usageTypeAnswer === 'commercial' && whouldYouBuyAnswer && whouldYouBuyAnswer !== 'no'">
                                            <CRow class="mt-3">
                                                <CCol  sm="6">
                                                    <CInput
                                                        required
                                                        label="How many rowers do you have? (last question)"
                                                        :is-valid="errors.ownedRowersNumberIsValid"
                                                        :invalid-feedback="errors.ownedRowersNumberInvalidFeedback"
                                                        v-model="ownedRowersNumber"
                                                    />
                                                </CCol>
                                            </CRow>
                                        </template>
                                    </CCardBody>
                                </CCard>
                            </CCol>
                        </CRow>
                        <CRow>
                            <CCol style="text-align:center">
                                <p style="color:red" v-for="error in errors" :key="error.fieldName">{{ error.fieldName }}: {{ error.message }}</p>
                                <CButton type="submit" class="px-5" color="success" :disabled="this.graphqlLoadingFlag">GET PHOTO</CButton>
                            </CCol>
                        </CRow>
                    </CForm>
                </CCardBody>
                <CCardBody v-else >
                    <CRow style="justify-content: center">
                        <h1 style="margin-top: 50px; margin-right: 100px; margin-left: 100px">Success! You will receive your photo at the nearest time</h1>
                    </CRow>
                </CCardBody>
            </CCard>
        </CWrapper>
    </div>
</template>

<script>
    import {store} from '@/scripts/globals'
    import {getProcessedResponseErrorsFlat, onSubmitHandler} from '@/scripts/forms-utils'
    import gql from 'graphql-tag'
    import authenticatedView from "@/mixins/authenticated-view";
    import fileUtils from "@/mixins/file-utils";

    export default {
        mixins: [authenticatedView, fileUtils],
        components: {
        },
        data() {
            return {
                errors: [],
                graphqlLoadingFlag: false,
                success: false,
                store,
                email: '',
                name: '',
                whouldYouBuyAnswer: '',
                whyWouldntBuyAnswer: '',
                usageTypeAnswer: '',
                ownedRowersNumber: '',
                customReasonNotToBuyAnswer: '',
                alreadyOwnedRowerBrandAnswer: '',
            }
        },
        methods: {
            async onSubmit() {
                let mutation = gql`
                    mutation {
                        onlineTrainingExhibitionUserQuestionary (
                            email: "${this.email}",
                            name: "${this.name}",
                            whouldYouBuyAnswer: "${this.whouldYouBuyAnswer}",
                            whyWouldntBuyAnswer: "${this.whyWouldntBuyAnswer}",
                            usageTypeAnswer: "${this.usageTypeAnswer}",
                            ownedRowersNumber: "${this.ownedRowersNumber}",
                            customReasonNotToBuyAnswer: "${this.customReasonNotToBuyAnswer}",
                            alreadyOwnedRowerBrandAnswer: "${this.alreadyOwnedRowerBrandAnswer}",
                            thumbnailId: "${this.$route.params.thumbnailId}"
                        ) {
                            success
                            errors
                        }
                    }
                `

                if (this.whouldYouBuyAnswer === 'no') {
                    this.usageTypeAnswer = ''
                    this.ownedRowersNumber = ''
                }
                else {
                    this.whyWouldntBuyAnswer = ''
                    this.customReasonNotToBuyAnswer = ''
                    this.alreadyOwnedRowerBrandAnswer = ''
                } 
                
                if (this.usageTypeAnswer !== 'commercial')
                    this.ownedRowersNumber = ''

                if (this.whyWouldntBuyAnswer !== 'not_interested')
                    this.customReasonNotToBuyAnswer = ''


                if (this.whyWouldntBuyAnswer !== 'another_smart_rower')
                    this.alreadyOwnedRowerBrandAnswer = ''
                    

                await onSubmitHandler(this, mutation,
                    {
                        onSuccessF: (res, scope) => {
                            scope.success = true
                        },
                        setErrorsF: (errors, scope) => scope.errors = getProcessedResponseErrorsFlat(errors,
                            ['email', 'name',
                                'whouldYouBuyAnswer',
                                'whyWouldntBuyAnswer',
                                'usageTypeAnswer',
                                'ownedRowersNumber',
                                'customReasonNotToBuyAnswer',
                                'alreadyOwnedRowerBrandAnswer',])
                    }
                )
            }
        },
        watch: {
            whouldYouBuyAnswer() {
                this.errors = []
            },

            email() {
                this.errors = []
            }
        }
    }
</script>


<style lang="scss">
    @media (min-width: 992px) and (max-width: 1200px) {
        .profile {
            .form-row {
                flex-direction: column;

                .col-form-label, .col-sm-9 {
                    max-width: 100% !important;
                }
            }
        }
    }

    .profile {
        &-avatar {
            width: 60px;
            height: 60px;
            border-radius: 50%;
            background-color: #dce0e7;

            .badge {
                border-radius: 50%;
                position: absolute;
                top: 0;
                right: -5px;
                width: 20px;
                height: 20px;
                padding: 4px 5px;
                z-index: 2;
                background-color: #ccc;
            }
        }
    }

    .form-group {
        position: relative;

        .invalid-feedback {
            position: absolute;
            margin-top: 0;
        }
    }
</style>
